export default "<app-header [header]=\"'Recommendations'\"></app-header>\r\n<app-bulk-backtest></app-bulk-backtest>\r\n";